import React, { useContext, useEffect, useState } from "react";
import {
    Dialog,
    DialogContent,
    DialogTitle,
    Box,
    Grid,
    Typography
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import MROButton from "components/buttons";
import PlanningLineMaintenance from 'lib/services/api/planning/LineMaintenance/lineEventsandSeries';
import { ToastMessageContext } from "lib/contexts/message_context";
import WarningIcon from "@material-ui/icons/Warning";
import CapabilityServices from "lib/services/api/compliance/capability_client";



const useStyles = makeStyles((theme) => ({
    actionButtons: {
        paddingTop: "20px",
        paddingBottom: "33px",
        textAlign: "right",
        "& button:not(:last-child)": {
            marginRight: "20px",
        },
    },
    modal: {
        "& .MuiDialog-paperWidthMd": {
            maxWidth: "550px",
        },
    },
    title: {
        fontSize: '22px',
        "& h2": {
            color: theme.palette.primary.main,

        },

        "& span": {
            color: theme.palette.primary.main,
            fontSize: 22,
            textAlign: 'center'
        },
    },
    card: {
        padding: "0 25px",
    },
}));


export default function Deleteitem(props) {
    const classes = useStyles();
    const { handleClose, getTechListing, currentSelection } = props
    const message = useContext(ToastMessageContext)
    const [loading, setLoading] = useState(false)

    const handleSubmit = async (e) => {
        const formData = {
            id: currentSelection.id
        }

        try {

            setLoading(true)
            const response = await CapabilityServices.deleteTechData(formData);
            if (response.success) {
                message.showToastMessage({
                    message: response?.message ? response?.message : "Deleted sucessfully",
                    variant: "success",
                });
                handleClose()
                getTechListing()
            }
            else {
                message.showToastMessage({
                    message: response?.error ? response?.error : "Something went wrong. Try again",
                    variant: "error",
                });
                handleClose()
                getTechListing()
            }
        } catch (error) {
            message.showToastMessage({
                message: "Something went wrong. Try again",
                variant: "error",
            });
            setLoading(false)
        }
        setLoading(false)
    }


    return (
        <div>
            <Dialog
                maxWidth={"md"}
                fullWidth={true}
                open={true}
                className={classes.modal}
                onClose={handleClose}
                aria-labelledby="delete-event"
            >
                <DialogTitle
                    variant="subtitle1"
                    color="secondary"
                    className={classes.title}
                >
                    <Typography style={{ textAlign: 'center', fontSize: '22px', }}>Warning</Typography>
                </DialogTitle>
                <DialogContent>
                    <Grid container style={{ paddingLeft: '26%' }}> <WarningIcon
                        style={{
                            color: "#FFB300",
                            marginRight: "10px",
                            fontSize: 20,
                            marginTop: '2px'
                        }}
                    /> <Typography>This action cannot be undone!</Typography></Grid>
                    <br />
                    <Typography style={{ textAlign: 'center' }}>Are you sure you want to continue?</Typography>
                </DialogContent>
                <Box
                    display="flex"
                    width="100%"
                    justifyContent="center"
                    my="25px"
                    align="center"
                >
                    <MROButton
                        type="button"
                        variant={"contained"}
                        onClick={handleClose}
                        style={{ marginRight: 20 }}
                    >
                        Cancel
                    </MROButton>
                    <MROButton
                        color="primary"
                        onClick={handleSubmit}
                        variant={"contained"}
                        loading={loading}
                    >
                        Yes
                    </MROButton>
                </Box>
            </Dialog>

        </div>
    )
}
